import { createGlobalStyle } from "styled-components";
import "react-toastify/dist/ReactToastify.css";

export default createGlobalStyle`
  * {
    margin : 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  
  *:focus{
    outline: 0
  }
  
  html, body, #root {
    height: 100%;
    background-color: var(--neutral-strongest) !important;
  }
  
  body {
    -webkit-font-smoothing: antialiased;
  }
  
  body, input, button {
    font : 14px 'Roboto', sans-serif;
  }
  
  a {
    text-decoration: none !important;
    color: var(--brand-primary) !important;
    cursor: pointer;

    :hover {
      text-decoration: underline !important;
    }
  }
  
  ul {
    list-style : none;
  }
  
  button{
    cursor :pointer;
  }
  
  .dropdown,
  .dropdown-toggle {
    font-family: var(--font-family-metropolis-regular);
    font-weight: 400;

    .dropdown-toggle::after {
      position: absolute;
      right: 1%;
      top: 50%;
      margin-right: 10px;

      transition: transform 0.3s ease;
      transform: rotate(0deg);
    }
      
    .dropdown-toggle[aria-expanded="true"]::after {
      transition: transform 0.3s ease;
      transform: rotate(180deg);
    }
  
    .dropdown-menu {
      background-color: var(--neutral-strong);
      overflow-y: auto;
      border: 2px solid var(--neutral-strong);
      border-radius: 8px;
      min-width: 20%;
      width: 100%;
    }
  
    .dropdown-item {
      font-size: 14px;
      color: var(--neutral-smoothest) !important;
      padding: 16px;
      line-height: 1.7;
      text-overflow: ellipsis;
      white-space: break-spaces;
      
      &:active,
      &:hover {
        background-color: rgba(19, 20, 27, 0.24) !important;
        text-decoration: none !important;
      }

    }
  }

  .popover {
    --bs-popover-max-width: 20rem;

    width: 100%;
    background-color: var(--neutral-strongest);
    z-index: 1001;

    .popover-arrow {
      &:before,
      &:after {
        border-top-color: var(--neutral-strongest);
      }
    }

    .popover-header {
      background-color: var(--brand-primary);
      color: var(--neutral-stronger);
    }
      
    .popover-body {
      background: var(--neutral-strongest);
    }
  }

  :root {
    /* FONT-FAMILY */
    --font-family-metropolis: 'Metropolis';
    --font-family-metropolis-regular: 'MetropolisRegular';
    --font-family-metropolis-semi-bold: 'MetropolisSemiBold';

    /* COLORS */
    --brand-primary: ${({ theme }) => theme.colors.brand_primary};
    --brand-orange: ${({ theme }) => theme.colors.brand_orange};

    --neutral-strong: ${({ theme }) => theme.colors.neutral_strong};
    --neutral-stronger: ${({ theme }) => theme.colors.neutral_stronger};
    --neutral-strongest: ${({ theme }) => theme.colors.neutral_strongest};
    --neutral-medium: ${({ theme }) => theme.colors.neutral_medium};
    --neutral-smooth: ${({ theme }) => theme.colors.neutral_smooth};
    --neutral-smoother: ${({ theme }) => theme.colors.neutral_smoother};
    --neutral-smoothest: ${({ theme }) => theme.colors.neutral_smoothest};

    --feedback-success: ${({ theme }) => theme.colors.feedback_success};
    --feedback-info: ${({ theme }) => theme.colors.feedback_info};
    --feedback-positive: ${({ theme }) => theme.colors.feedback_positive};
    --feedback-warning: ${({ theme }) => theme.colors.feedback_warning};
    --feedback-negative: ${({ theme }) => theme.colors.feedback_negative};
    --feedback-error: ${({ theme }) => theme.colors.feedback_error};


    /* FONT-SIZE */
    --font-size-small: ${({ theme }) => theme.fontSizes.small};
    --font-size-default: ${({ theme }) => theme.fontSizes.default};
    --font-size-huge: ${({ theme }) => theme.fontSizes.huge};
    --font-size-tiny: ${({ theme }) => theme.fontSizes.tiny};

  /* SPACING */
    --spacing-small: ${({ theme }) => theme.spacing.small};
    --spacing-default: ${({ theme }) => theme.spacing.default};
    --spacing-vertical: ${({ theme }) => theme.spacing.vertical};
    --spacing-horizontal: ${({ theme }) => theme.spacing.horizontal};
    --spacing-huge: ${({ theme }) => theme.spacing.huge};
    --spacing-tiny: ${({ theme }) => theme.spacing.tiny};
  
  /* BUTTON */
    --vm-btn-disabled-opacity: 0.24;
    --vm-btn-hover: 0.97;
  }
`;
